import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'membership_cancellation';
export const route = 'membership_cancellation/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "membershipcancellation" */
'../../components/MembershipCancellation')));